import {LastCallError} from './LastCallError.js'

export class ShowLastCallError extends LastCallError {}
